import { memo } from 'react';
import { FullpageArgs } from 'root/@types/fullpageArgs';
import ContentFrame from 'ui/ContentFrame/ContentFrame';
import SectionTitle from 'ui/SectionTitle/SectionTitle';
import Board from './elements/Board';
import './About.scss';

const About: React.FC<{fullpage?: FullpageArgs}> = memo(({ fullpage = {} }) => {

  return (
    <div className="about centered" id="about">
      <div className="about__video">
        <video
          src={require('media/about.mp4')}
          muted
          playsInline
          loop
          autoPlay
          data-keepplaying
        ></video>
      </div>
      <div className="container about__container">
        <ContentFrame className="about__wrapper" title="About">
          <div className="about__content">
            <SectionTitle className="about__title">
              <span>About</span>
            </SectionTitle>
            <Board />
          </div>
        </ContentFrame>
      </div>
    </div>
  );
});

export default About;
